import {
	Component,
	EventEmitter,
	Input,
	OnChanges,
	OnInit,
	Output,
	SimpleChanges
} from '@angular/core';
import {
	Template,
	TemplatesWithOptions
} from '@web-components/settings/settings.model';
import { PageRequest } from '@models/models';
import { PaginationService } from '@services/pagination/pagination.service';
import { NewSubscriptionServiceDataProvider } from '@services/subscription/subscription.service';

@Component({
	selector: 'template-list',
	template: require('./template-list.html'),
	styles: [require('./template-list.scss')]
})
export class TemplateListComponent implements OnInit, OnChanges {
	@Input() templates: TemplatesWithOptions<Template>;
	@Input() btnDisable: boolean;
	@Input() pageRequest: PageRequest;
	@Output() onEdit: EventEmitter<Template> = new EventEmitter();
	@Output() onDuplicate: EventEmitter<Template> = new EventEmitter();
	@Output() onDelete: EventEmitter<Template> = new EventEmitter();
	@Output()
	updatePaginationParams: EventEmitter<PageRequest> = new EventEmitter();

	pageNumbers: Array<number> = [];
	totalItems: number;
	currentActiveId: string;

	constructor(
		private paginationService: PaginationService,
		private subscriptionService: NewSubscriptionServiceDataProvider
	) {}

	ngOnInit(): void {
		this.updatePageRequestParams();
	}

	ngOnChanges(changes: SimpleChanges): void {
		if (
			changes.templates &&
			!changes.templates.isFirstChange() &&
			changes.templates.currentValue.items.length
		) {
			this.updatePageRequestParams();
		}
	}

	updateTemplate(data): void {
		this.updatePaginationParams.emit(data);
	}

	edit(template: Template): void {
		this.onEdit.emit(template);
	}

	duplicate(template: Template): void {
		if (template.formActions.UPGRADE_PLAN_FOR_DUPLICATE_FORM) {
			this.subscriptionService.setChoosePlanOpenModalStatus({
				state: true,
				payload: {
					url: template.formActions.UPGRADE_PLAN_FOR_DUPLICATE_FORM.url
				}
			});
		} else {
			this.currentActiveId = template.id;
			this.onDuplicate.emit(template);
		}
	}

	deleteItem(template: Template): void {
		this.onDelete.emit(template);
	}

	orderByField(field: string): void {
		this.pageRequest.sortCriterias[0].fieldName = field;
		this.pageRequest.sortCriterias[0].sortAscending = !this.pageRequest
			.sortCriterias[0].sortAscending;
		this.updateTemplate(this.pageRequest);
	}

	private updatePageRequestParams(): void {
		this.totalItems = this.templates.totalSize;
		this.pageNumbers = this.paginationService.calculatePageNumbers(
			this.totalItems,
			this.pageRequest.paging.pageSize
		);
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=oom9nsliule!./web/modern/components/settings/common/template-list/template-list.ts